import { SvgIcon, SvgIconProps } from '@components/shared/SvgIcon'

export function ChatLightIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill={'none'}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.0714 19.5699C16.0152 22.6263 11.4898 23.2867 7.78642 21.574C7.23971 21.3539 6.79148 21.176 6.36537 21.176C5.17849 21.183 3.70117 22.3339 2.93336 21.567C2.16555 20.7991 3.31726 19.3206 3.31726 18.1266C3.31726 17.7004 3.14642 17.2602 2.92632 16.7124C1.21283 13.0096 1.87411 8.48269 4.93026 5.42721C8.8316 1.52443 15.17 1.52443 19.0714 5.4262C22.9797 9.33501 22.9727 15.6681 19.0714 19.5699Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.9408 12.9131H15.9498"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9291 12.9131H11.9381"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.92128 12.9131H7.93028"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  )
}
